import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function QueAprenderas() {
  const revealRef = useScrollReveal();
  const gridRef = useScrollReveal();
  const items = [{
    num: '01',
    text: 'La ciencia detrás de las harinas sin gluten y cómo elegir la correcta para cada tipo de pasta'
  }, {
    num: '02',
    text: 'Fórmula exacta de hidratación para lograr masa elástica y manejable sin gluten'
  }, {
    num: '03',
    text: 'Espagueti casero al dente: la receta base de El Método Italiano™ desde cero'
  }, {
    num: '04',
    text: 'Fettuccine artesanal con mezcla de almidón de tapioca que imita la textura del trigo'
  }, {
    num: '05',
    text: 'Pasta rellena (ravioles) sin gluten sin que se rompa al hervirla'
  }, {
    num: '06',
    text: 'Penne rigate crujiente horneado con técnica italiana de doble cocción'
  }, {
    num: '07',
    text: 'Errores de principiante que arruinan la masa y cómo evitarlos antes de empezar'
  }, {
    num: '08',
    text: 'Tiempos de cocción diferenciados por tipo de harina — no hay un único "8 minutos"'
  }, {
    num: '09',
    text: 'Cómo conservar la pasta cruda y cocida para que dure sin perder calidad'
  }, {
    num: '10',
    text: '5 salsas italianas clásicas calibradas específicamente para pasta sin gluten'
  }, {
    num: '11',
    text: 'Menú semanal completo para celiaco sin renunciar a la variedad ni al sabor'
  }, {
    num: '12',
    text: 'Lista de compras optimizada para preparar toda la semana en una sola sesión de cocina'
  }];
  return <section id="que-aprenderas" className="bg-carbon py-14 sm:py-[90px] px-6" data-id="element-333">
      <div ref={revealRef} className="max-w-[1060px] mx-auto reveal" data-id="element-334">
        <div className="text-center" data-id="element-335">
          <span className="text-[11px] tracking-[5px] uppercase text-oro mb-4 block" data-id="element-336">
            Contenido del ebook
          </span>
          <h2 className="font-playfair text-[clamp(28px,4.5vw,52px)] font-bold leading-[1.15] mb-6" data-id="element-337">
            Todo lo que dominarás
            <br data-id="element-338" />
            con este método
          </h2>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-oro to-transparent mx-auto my-5" data-id="element-339"></div>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-12 stagger-children" data-id="element-340">
          {items.map((item, index) => <div key={index} className="flex gap-3.5 items-start p-4.5 bg-gris-oscuro rounded-sm border-l-2 border-oro text-[14px] leading-[1.6] text-white/85 transition-colors duration-200 hover:bg-gris-medio" data-id="element-341">
              <span className="font-montserrat font-black text-oro text-[18px] shrink-0 min-w-[28px]" data-id="element-342">
                {item.num}
              </span>
              <span data-id="element-343">{item.text}</span>
            </div>)}
        </div>
      </div>
    </section>;
}